import type { FormEvent } from 'react'
import useContractsFilters from '../../ContractsFilters/useContractsFilters'
import { DashboardV2Filters } from '../../types'
import { searchButtonOverrides } from '../styled-components'

type SearchKey =
  'subscriptionId' | 'zohoId' | 'meterIdElectricity' | 'meterIdGas' | 'lastname' | 'firstname' | 'email' | 'phone'

const SEARCH_FIELDS: Array<{ key: SearchKey; labelKey: string; energyOnly?: boolean }> = [
  { key: 'subscriptionId', labelKey: 'dashboard:filters.contract_id' },
  { key: 'zohoId', labelKey: 'dashboard:filters.zoho_id' },
  { key: 'meterIdElectricity', labelKey: 'dashboard:filters.meter_id_elec', energyOnly: true },
  { key: 'meterIdGas', labelKey: 'dashboard:filters.meter_id_gas', energyOnly: true },
  { key: 'lastname', labelKey: 'dashboard:filters.lastname' },
  { key: 'firstname', labelKey: 'dashboard:filters.firstname' },
  { key: 'email', labelKey: 'dashboard:filters.email' },
  { key: 'phone', labelKey: 'dashboard:filters.phone' },
]

interface UseSearchCardParams {
  filters: DashboardV2Filters
  applicationType: string
}

const useSearchCard = ({ filters, applicationType }: UseSearchCardParams) => {
  const { t, dispatchFilters } = useContractsFilters({ filters })
  const fields = SEARCH_FIELDS.filter(field => !field.energyOnly || applicationType === 'energie')

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const typed = new FormData(event.currentTarget)
    const changed = fields.filter(field => String(typed.get(field.key) ?? '').trim() !== (filters[field.key] ?? ''))
    if (changed.length === 0) return

    dispatchFilters(
      changed.reduce((next, field) => ({ ...next, [field.key]: String(typed.get(field.key) ?? '').trim() }), filters),
    )
  }

  return {
    title: t('dashboard:overview.search_title'),
    fields: fields.map(field => ({ key: field.key, label: t(field.labelKey), value: filters[field.key] ?? '' })),
    submitLabel: t('common:search'),
    submitOverrides: searchButtonOverrides,
    onSubmit,
  }
}

export default useSearchCard
